export const ROUTES = {
  home: "/",
  payments: "/payments",
  newPayment: "/payments/new",
  finance: "/finance",
  serviceRequest: "/service-request",
  serviceRequestDetails: "/service-request/:requestID",
  leaseDetails: "/lease/:leaseID",
  leaseDocs: "/lease/:leaseID/docs",
  tenantTable: "/tenant",
  tenantDetails: "/tenant/:tenantID",
  tenantDetailsLease: "/tenant/:tenantID/lease",
  addTenant: "/add-tenant",
  amenity: "/amenity",
  amenityDetails: "/property/:propertyID/amenity/:amenityID",
  unitPlan: "/unit-plan",
  unitPlanDetails: "/property/:propertyID/unit-plan/:unitPlanID",
  addUnitPlan: "/add-unit-plan",
  leaseTable: "/lease",
  leaseUpdate: "/lease/update",
  stays: "/stays",
  unitTable: "/unit",
  unitDetails: "/unit/:unitID",
  addUnit: "/add-unit",
  buildingTable: "/building",
  buildingDetails: "/building/:buildingID",
  addBuilding: "/add-building",
  parcelTable: "/parcel",
  parcelDetails: "/parcel/:parcelID",
  addParcel: "/add-parcel",
  propertyTable: "/property",
  propertyDetails: "/property/:propertyID",
  addProperty: "/add-property",
  organization: "/organization",
  newOrganization: "/organization/new",
  organizationDetails: "/organization/:organizationID",
  orgMemberDetails: "/organization/:organizationID/member/:userID",
  calendar: "/calendar",
  messages: "/messages",
  settings: "/settings",
  account: "/account",
  help: "/help",
} as const;

type RouteWithParams =
  | "serviceRequestDetails"
  | "leaseDetails"
  | "leaseDocs"
  | "tenantDetails"
  | "tenantDetailsLease"
  | "organizationDetails"
  | "propertyDetails"
  | "buildingDetails"
  | "unitDetails"
  | "orgMemberDetails"
  | "amenityDetails"
  | "unitPlanDetails";

// Type for route keys that have tours
export type TourRouteKey =
  | "home"
  | "propertyTable"
  | "propertyDetails"
  | "addProperty"
  | "buildingTable"
  | "buildingDetails"
  | "addBuilding"
  | "unitTable"
  | "unitDetails"
  | "addUnit"
  | "tenantTable"
  | "tenantDetails"
  | "addTenant"
  | "leaseTable"
  | "leaseDetails"
  | "serviceRequest"
  | "serviceRequestDetails"
  | "organization"
  | "organizationDetails"
  | "orgMemberDetails"
  | "calendar"
  | "messages"
  | "settings"
  | "account"
  | "help"
  | "payments"
  | "finance"
  | "amenity"
  | "amenityDetails"
  | "unitPlan"
  | "unitPlanDetails";
/**
 * Replaces route parameters with actual IDs
 * @param routeKey - The key from ROUTES object that contains parameters
 * @param params - Object containing the parameter values to replace
 * @returns The route with parameters replaced
 * @example
 * // For routes with one parameter
 * getRouteWithParams("leaseDetails", { leaseID: "123" })
 * // Returns: "/lease/123"
 *
 * // For routes with two parameters
 * getRouteWithParams("leaseApplication", { entityType: "tenant", entityID: "456" })
 * // Returns: "/lease-application/tenant/456"
 */
export const getRouteWithParams = (
  routeKey: RouteWithParams,
  params: Record<string, string>
): string => {
  let route: string = ROUTES[routeKey];

  // Replace each parameter in the route
  Object.entries(params).forEach(([key, value]) => {
    route = route.replace(`:${key}`, value);
  });

  return route;
};
